<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Scopo del progetto')">
    <wizard-searched-domain-info v-if="wizard.searchedDomain && wizard.availableDomain !== null" />

    <wizard-question
      :title="
        wizard.nomeDominio ? $t('Quali servizi vuoi associare al dominio scelto: {0}', [wizard.nomeDominio]) : $t('Quale tipologia di servizio ti occorre?')
      "
    >
      <template #description v-if="!wizard.nomeDominio">
        {{ $t('Come prima cosa ti chiediamo di indicarci qual è la tipologia di servizio che stai cercando.') }}
      </template>

      <wizard-question-path v-model="wizard.path" name="path" required />
    </wizard-question>
  </wizard-form>
</template>

<style scoped>
:deep(.pf-v6-c-radio) {
  margin-bottom: var(--pf-t--global--spacer--md);
}
</style>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';
import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionPath from '../questions/wizard-question-path.vue';
import WizardForm from '../wizard-form.vue';
import wizardSearchedDomainInfo from '../wizard-searched-domain-info.vue';

defineOptions({
  name: 'WizardStepScopo',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => true,
});

defineExpose({
  isEnabled,
});
</script>
